// This file was auto-generated by Fern from our API Definition.
export const MetricType = {
    NumericContinuous: "numeric/continuous",
    NumericDiscrete: "numeric/discrete",
    Binary: "binary",
    CategoricalSingle: "categorical/single",
    CategoricalMultiple: "categorical/multiple",
    String: "string",
    Json: "json",
    None: "none",
    All: "*",
};
